import { transformAddress } from './address';
export const transformNationality = nationality => ({
  code: nationality.code,
  title: nationality.title
});
export const transformPaymentsAccount = paymentsAccount => ({
  firstName: paymentsAccount.first_name,
  lastName: paymentsAccount.last_name,
  birthdate: paymentsAccount.birthdate,
  nationality: paymentsAccount.nationality ? transformNationality(paymentsAccount.nationality) : null,
  address: paymentsAccount.user_address ? transformAddress(paymentsAccount.user_address) : null
});